export default __webpack_public_path__ + "static/media/girl.138ab72e.svg";